module.exports = __webpack_public_path__ + "media/images/athletes/2489-259ee2d3368799477e7b03feff806948.png";